import axios from 'axios';
import { getRateLimitHeaders } from '../utils/sessionId';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

// VIN decode (rate-limited)
export const decodeVIN = async (vin) => {
  const response = await api.post('/vin/decode', { vin }, {
    headers: getRateLimitHeaders()
  });
  return response.data;
};

// Get coverage options
export const getCoverageOptions = async () => {
  const response = await api.get('/coverage-options');
  return response.data;
};

// Calculate quote (rate-limited)
export const calculateQuote = async (quoteData) => {
  const response = await api.post('/quote/calculate', quoteData, {
    headers: getRateLimitHeaders()
  });
  return response.data;
};

// Save quote
export const saveQuote = async (quote) => {
  const response = await api.post('/quote/save', quote);
  return response.data;
};

// Get quote by ID
export const getQuote = async (quoteId) => {
  const response = await api.get(`/quote/${quoteId}`);
  return response.data;
};

// Email quote
export const emailQuote = async (quoteId, email, name) => {
  const response = await api.post('/quote/email', { 
    quote_id: quoteId, 
    email: email, 
    customer_name: name 
  });
  return response.data;
};

// Create payment checkout session
export const createCheckoutSession = async (quoteId, saveCardConsent = false) => {
  const originUrl = window.location.origin;
  const response = await api.post('/payment/checkout', { 
    quote_id: quoteId, 
    origin_url: originUrl,
    save_card_consent: saveCardConsent
  });
  return response.data;
};

// Get payment consent text
export const getPaymentConsentText = async () => {
  const response = await api.get('/payment/consent-text');
  return response.data;
};

// Record payment consent after payment
export const recordPaymentConsent = async (policyNumber, consentData) => {
  const params = new URLSearchParams({
    policy_number: policyNumber,
    save_card_consent: consentData.save_card_consent,
    ...(consentData.payment_method_id && { payment_method_id: consentData.payment_method_id }),
    ...(consentData.card_brand && { card_brand: consentData.card_brand }),
    ...(consentData.card_last4 && { card_last4: consentData.card_last4 }),
    ...(consentData.stripe_customer_id && { stripe_customer_id: consentData.stripe_customer_id })
  });
  const response = await api.post(`/payment/record-consent?${params}`);
  return response.data;
};

// Get payment status
export const getPaymentStatus = async (sessionId) => {
  const response = await api.get(`/payment/status/${sessionId}`);
  return response.data;
};

// Get policy by session
export const getPolicyBySession = async (sessionId) => {
  const response = await api.get(`/policy/${sessionId}`);
  return response.data;
};
